import { useEffect, useRef } from 'react';
import { useInView } from 'framer-motion';

/**
 * Hook personnalisé pour déclencher des animations au scroll
 * @param threshold - Pourcentage de visibilité requis (0-1)
 * @param once - Si true, l'animation ne se déclenche qu'une fois
 */
export function useScrollAnimation(threshold = 0.2, once = true) {
  const ref = useRef<HTMLDivElement>(null);
  const isInView = useInView(ref, {
    once,
    margin: '-100px', // Trigger un peu avant que l'élément soit visible
  });

  return { ref, isInView };
}
